module.exports = __webpack_public_path__ + "assets/61398dd9d753de248c90cb89619e721c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team/carolina.jpg
// module id = 511
// module chunks = 0